import useReportContent from './useReportContent.js';

export { useReportContent };
